import React, { useState } from "react";
import {
  FlexRowBetween,
  GenericDiv,
  Input,
  Label,
  PopupForm,
  RespFont,
} from "../../../common/Style";
import OverlayTrigger from "react-bootstrap/esm/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import OWC from "../OWC";
import { useSelector } from "react-redux";
import dropdown from "../../../../assets/common/dropdown.svg";
import { toast } from "react-toastify";

const ConnectionOtherEvent = ({ func, init }) => {
  const { user } = useSelector((state) => state.authReducer);

  const [inviting, setInviting] = useState("");
  const defaultPreSms1 = `הנכם מוזמנים ל${user.calendarName}`;

  return (
    <PopupForm onClick={(e) => e.stopPropagation()}>
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        <Label style={{ marginTop: "30px" }}>הוספת תיאור</Label>
        <Input
          onChange={(e) => setInviting(e.target.value)}
          placeholder="כתבו כאן..."
        />

        <FlexRowBetween
          style={{ width: "90%", margin: "0 auto", marginBottom: "20px" }}
        >
          <RespFont>
            {inviting !== "" ? (
              `${defaultPreSms1} ${inviting}`
            ) : (
              <>ברירת מחדל: {defaultPreSms1}</>
            )}
          </RespFont>
        </FlexRowBetween>
        <GenericDiv
          onClick={() => func({ inviting }, init)}
          style={{ margin: "10px auto", marginTop: "30px" }}
        >
          שמירה
        </GenericDiv>
      </div>
    </PopupForm>
  );
};

export default ConnectionOtherEvent;
